var _rect, _rect2, _line, _rect3, _rect4, _rect5, _rect6, _circle, _rect7, _ellipse, _ellipse2, _line2, _line3, _ellipse3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductShot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#190A4E"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "floor",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2D1B69",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#190A4E",
      stopOpacity: 1
    }
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 400,
    width: 600,
    height: 200,
    fill: "url(#floor)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 400,
    x2: 600,
    y2: 400,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 350,
    width: 140,
    height: 50,
    fill: "#3D2B89",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 340,
    width: 160,
    height: 15,
    fill: "#4D3B99",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 220,
    width: 60,
    height: 120,
    rx: 8,
    fill: "#FFB02E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 200,
    width: 80,
    height: 25,
    rx: 12,
    fill: "#E09920"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 212,
    r: 8,
    fill: "#190A4E",
    opacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 270,
    width: 40,
    height: 30,
    fill: "#190A4E",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 150,
    rx: 60,
    ry: 60,
    fill: "#FFFFFF",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 180,
    rx: 50,
    ry: 50,
    fill: "#FFFFFF",
    opacity: 0.08
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 100,
    x2: 270,
    y2: 220,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 140,
    x2: 330,
    y2: 220,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 400,
    rx: 80,
    ry: 15,
    fill: "#000000",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00D9FF",
    strokeWidth: 3,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "50,80 50,50 80,50",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "520,50 550,50 550,80",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "550,520 550,550 520,550",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "80,550 50,550 50,520",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShot);
export default __webpack_public_path__ + "static/media/product-shot.1c335dbbaa3096aff5051ddfd383fdad.svg";
export { ForwardRef as ReactComponent };